import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextEditor } from '../../ui/TextEditor';

interface Props {
  disabled?: boolean;
}

export const PropertySellingPointsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <TextEditor
      disabled={disabled}
      fieldName="descriptions.propertySellingPoints"
      label={t('dashboard.assets.addedit.main.generalinfo.fields.propertySellingPoints.label')}
      placeholder={t('dashboard.assets.addedit.main.generalinfo.fields.propertySellingPoints.placeholder')}
    />
  );
};
